/**
 * Die gemeinsame Schale der fünf Auftragnehmer-Bildschirme. Dieselbe Zusage wie bei `/t/:id`: kein
 * Bildschirm unter `/me` ohne Sitzung. Die einzelnen Dateien tragen ihren eigenen
 * `<RequireSession>` weiterhin — er kostet nichts (dieselbe Abfrage, derselbe Cache) und hält jeden
 * Bildschirm für sich testbar; verlassen muss man sich darauf nicht mehr.
 */
import { Outlet, createFileRoute } from '@tanstack/react-router'
import type { ReactElement } from 'react'
import { RequireSession } from '../../auth'

export const Route = createFileRoute('/me')({
  component: MeSchale,
})

function MeSchale(): ReactElement {
  return (
    <RequireSession>
      <Outlet />
    </RequireSession>
  )
}
